import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DEFAULT_ROUTES_BY_ROLE } from '@shared/records/default-routes-by-role.record';
import { RbsService } from '@auth/services/rbs.service';

export const hasSelectedRoleGuard: CanActivateFn = (_, state) => {
  const router = inject(Router);
  const rbsService = inject(RbsService);

  const authLandingRoute = '/login/auth-landing';
  const isAuthLanding = state.url.startsWith(authLandingRoute);

  const userOrganizationList = rbsService.userOrganizationList();
  let selectedUserOrganization = rbsService.selectedUserOrganization();

  if (userOrganizationList.length === 1 && !selectedUserOrganization) {
    selectedUserOrganization = userOrganizationList[0];
    rbsService.selectedUserOrganization = selectedUserOrganization;
  }

  if (selectedUserOrganization) {
    const role = selectedUserOrganization.role;
    const defaultRoute = DEFAULT_ROUTES_BY_ROLE[role];
    return !isAuthLanding || router.createUrlTree([defaultRoute]);
  }

  return isAuthLanding || router.createUrlTree([authLandingRoute]);
};
